<template>
  <v-container grid-list-xs fluid>
    <v-layout row wrap text-xs-center my-2>
      <v-flex xs12>
        <form-wizard @on-complete="onComplete" :start-index="0" shape="tab" ref="wizard" color="#42A5F5">
          <h2 slot="title">ตั้งค่าหน้าร้านใหม่</h2>
          <tab-content title="การตั้งค่าข้อมูลร้าน" icon="fas fa-store" :before-change="validateFirstStep">
            <v-flex md6 sm6 xs12 text-xs-left pa-1>
              <h3>การตั้งค่าข้อมูลร้าน</h3>
            </v-flex>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex md6 sm6 xs12 text-xs-center class="hidden-sm-and-up">
                    <v-avatar
                      size="256"
                      :tile="true"
                      @click="
                        '';


                      "
                    >
                      <v-icon size="256" color="black" style="cursor: pointer;">fa-image</v-icon>
                      <img src="''" alt="alt" style="display: none;" />
                    </v-avatar>
                  </v-flex>
                  <v-flex md6 sm6 xs12>
                    <v-layout row wrap>
                      <v-flex xs12 pa-1>
                        <v-text-field :label="$t('CompanyName')" v-model="address_setting.companyname" hide-details />
                      </v-flex>
                      <v-flex x12 pa-1>
                        <v-text-field label="เลขที่ผู้เสียภาษี" v-model="address_setting.taxpayer_number" hide-details />
                      </v-flex>
                      <v-flex md12 sm12 xs12 text-xs-left pa-1 style="margin-top:25px;">
                        <h3>{{ $t("Address") }}</h3>
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('Building')" v-model="address_setting.building" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('Room_No')" v-model="address_setting.room_no" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('Floor')" v-model="address_setting.floor" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('Village')" v-model="address_setting.village" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('House_No')" v-model="address_setting.house_no" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field :label="$t('Village_No')" v-model="address_setting.village_no" hide-details />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md6 sm6 xs12 text-xs-center class="hidden-xs-only">
                    <v-avatar size="256" :tile="false" @click="uploadPic()">
                      <v-icon size="256" color="black" style="cursor: pointer;" v-if="img == ''">fa-image</v-icon>
                      <img v-if="img != ''" :src="img" />
                      <input type="file" id="file1" name="image" ref="file1" class="upload" @change="onChangePicture($event, 1)" accept="image/*" capture style="display:none" />
                    </v-avatar>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Alley_Lane')" v-model="address_setting.alley_lane" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Road')" v-model="address_setting.road" hide-details />
                  </v-flex>

                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('SubDistrict_SubArea')" v-model="address_setting.subdistrict_subarea" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('District_Area')" v-model="address_setting.district_area" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Province')" v-model="address_setting.province" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('Zipcode')" v-model="address_setting.postcode" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 x12 pa-1>
                    <v-text-field :label="$t('TelephoneNumber')" v-model="address_setting.telephone1" hide-details />
                  </v-flex>
                  <v-flex md12 sm12 xs12 text-xs-left pa-1 style="margin-top:25px;">
                    <h3>Social Media</h3>
                  </v-flex>
                  <v-flex xs12 style="padding-top: 12px;">
                    <v-layout row wrap px-2>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field label="LINE ID" v-model="address_setting.line_id" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 xs12 pa-1>
                        <v-text-field label="FACEBOOK" v-model="address_setting.facebook" hide-details />
                      </v-flex>
                      <v-flex md6 sm6 x12 pa-1>
                        <v-text-field label="TWITTER" v-model="address_setting.twitter" hide-details />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </tab-content>
          <tab-content title="การตั้งค่าข้อมูลทั่วไป" icon="fas fa-cog">
            <v-flex md6 sm6 xs12 text-xs-left pa-1>
              <h3>การตั้งค่าข้อมูลทั่วไป</h3>
            </v-flex>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12 pa-1>
                <v-checkbox v-model="is_use_cal_tax" @change="changeTaxVal()" class="mx-2" :label="$t('Usetaxcalculationsystem')"></v-checkbox>
              </v-flex>
              <v-flex md6 sm6 xs12 pa-1>
                <v-checkbox v-model="is_use_cal_ss" @change="changeTaxVal1()" class="mx-2" :label="$t('Usesocialsecuritypaymentsystem')"></v-checkbox>
              </v-flex>
              <!-- <v-flex md6 sm6 xs12 pa-1>
                <v-text-field
                  label="เวลาสแกนซ้ำ(นาที)"
                  v-model="general_setting.finger_scan"
                  type="number"
                  
                />
              </v-flex>-->
              <v-flex md6 sm6 xs12 pa-1 style="display: none;">
                <v-text-field label="เวลาเริ่มคำนวนสาย(นาที)" v-model="general_setting.start_cal_late" type="number" />
              </v-flex>
              <v-flex md6 sm6 xs12 pa-1 style="display: none;">
                <v-text-field label="จำนวนวันทำงานที่ใช้คำนวณ(วัน)" v-model="general_setting.cal_work_day" type="number" />
              </v-flex>
              <v-flex md6 sm6 xs12 pa-1 style="display: none;">
                <v-text-field label="ทศนิยม คำนวณเงิน(นาที)" v-model="general_setting.cal_decimal" type="number" />
              </v-flex>
              <!-- <v-flex md6 sm6 xs12 text-xs-left style="padding-top: 12px;">
                <h3>รูปแบบการแสดงปี</h3>
                <v-layout row wrap>
                  <v-flex xs12 px-2>
                    <v-radio-group
                      v-model="general_setting.format_date"
                      :column="false"
                      
                    >
                      <template>
                        <v-radio label="พ.ศ." value="0" />
                        <v-radio label="ค.ศ." value="1" />
                      </template>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>-->
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12 text-xs-left style="padding-top: 12px;">
                <h3>รูปแบบการแสดงสัญลักษณ์เงินตรา</h3>
                <v-layout row wrap>
                  <v-flex xs12 px-2>
                    <v-radio-group v-model="general_setting.symbols_style" :column="false">
                      <template>
                        <v-radio label="ก่อน" value="0" />
                        <v-radio label="หลัง" value="1" />
                      </template>
                    </v-radio-group>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md6 sm6 xs12 pt-2 px-1>
                <v-text-field label="สัญลักษณ์เงินตรา" v-model="general_setting.currency_symbols" placeholder="ตย. บาท" />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex text-xs-left md12 sm12 xs12 pt-3>
                <h3>อัตราเงินประกันสังคม</h3>
              </v-flex>

              <v-flex md2 sm4 xs6 pa-1>
                <v-text-field label="อัตรา(%)" v-model="general_setting.ss_rate" type="number" />
              </v-flex>
              <v-flex md2 sm4 xs6 pa-1>
                <v-text-field label="ฐาน" v-model="general_setting.ss_base" type="number" />
              </v-flex>
            </v-layout>
          </tab-content>
          <tab-content title="การตั้งค่าภาษี" icon="fas fa-percent">
            <v-layout row wrap>
              <v-flex xs12>
                <h2>{{ $t("Calculation_income") }}</h2>
                <v-layout row wrap>
                  <v-flex lg1 md2 sm2 xs3 pa-3 text-xs-left>
                    <h4>{{ $t("Year_tax") }}</h4>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs9 px-1 text-xs-left>
                    <v-select v-model="years" :items="items" item-text="name" item-value="name" @input="getTaxDetail()"></v-select>
                  </v-flex>
                </v-layout>
                <v-layout row wrap style="display:none;">
                  <v-flex lg1 md3 sm3 xs4 pa-3>
                    <span>{{ $t("Otherincome") }}</span>
                    <!-- <v-text-field :label="$t('Otherincome')" v-model="model_tax.name" ></v-text-field> -->
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs8 px-3>
                    <v-text-field placeholder="0" type="number" v-model="income" />
                  </v-flex>
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md2 sm2 xs12 pa-3>
                    <h4>{{ $t("Deductible") }}</h4>
                  </v-flex>
                </v-layout>

                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg2 md2 sm2 xs6 pa-3>
                    <span>{{ $t("Lessexpenses") }}{{ $t("Rate") }}</span>
                  </v-flex>
                  <v-flex lg1 md2 sm2 xs3 pa-1>
                    <v-text-field label="Solo" placeholder="tax" type="number" v-model="taxsetting.less_exp_rate" solo />
                  </v-flex>
                  <v-flex lg1 md2 sm2 xs3 px-1>
                    <span>%</span>
                  </v-flex>
                  <v-flex lg1 md2 sm2 xs3 px-1>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs4 px-1>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.less_exp_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md2 sm2 xs4>
                    <span>{{ $t("personal") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3 px-1>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4 px-1>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_person" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("spouse") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3 px-1>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4 px-1>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_spouse" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("childen") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3 px-1>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4 px-1>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_child_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("residence") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_insurance_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("parent") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_parent_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("handicapped") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_handucap_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("insurance") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_inc_residence_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("parent_insurance") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_parent_insurance_base" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("LTF") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_ltf" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("long_insurance") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_long_insurance" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap text-xs-left>
                  <v-flex lg1 md1 sm1 xs1 px-1 class="hidden-xs-only"></v-flex>
                  <v-flex lg4 md3 sm3 xs4>
                    <span>{{ $t("RMF") }}</span>
                  </v-flex>
                  <v-flex lg1 md3 sm3 xs3>
                    <span>{{ $t("max_value") }}</span>
                  </v-flex>
                  <v-flex lg2 md3 sm3 xs4>
                    <v-text-field label="Solo" placeholder="0" type="number" v-model="taxsetting.reduce_rmf" solo />
                  </v-flex>
                  <!-- <v-flex lg3 md3 sm3 xs1 pa-2>
                    <span>{{$t('baht')}}</span>
                  </v-flex>-->
                </v-layout>
                <v-layout row wrap>
                  <h3>{{ $t("Otherallowances") }}</h3>
                </v-layout>
                <v-layout row v-for="(item, index) in data_allowances" :key="index">
                  <v-flex lg4 md4 sm4 xs4 pa-2>
                    <v-text-field label="name" v-model="item.name" />
                  </v-flex>
                  <v-flex lg3 md4 sm4 xs4 pa-2>
                    <v-text-field :label="$t('max_value')" v-model="item.max" />
                  </v-flex>
                  <v-flex lg2 md4 sm4 xs4 pa-3>
                    <span>{{ $t("Maximum_value") }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout row wrap py-2>
                <v-flex xs12 class="text-xs-left">
                  <v-btn color="success" @click="plusallowances()">
                    <v-icon :size="16">fa-plus</v-icon>
                    <span class="ml-2">{{ $t("Add_step") }}</span>
                  </v-btn>
                  <v-btn color="warning" @click="delallowances()">
                    <v-icon :size="16">fa-minus</v-icon>
                    <span class="ml-2">{{ $t("Step_down") }}</span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-flex xs12>
                <v-layout row wrap>
                  <h2>{{ $t("Tax_structure") }}</h2>
                </v-layout>
                <div v-if="data_tax.length > 0">
                  <v-layout row wrap v-for="(item, index) in data_tax" :key="index">
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field :label="$t('Fromtheamount')" v-model="item.from_value" hide-details />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs4 px-1>
                      <v-text-field :label="$t('Rate')" v-model="item.tax" hide-details />
                    </v-flex>
                  </v-layout>
                </div>
                <div v-else>
                  <v-layout row wrap v-for="(item, index) in taxstructure" :key="index">
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field :label="$t('Fromtheamount')" v-model="item.from_value" hide-details />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">-</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs5 px-1>
                      <v-text-field :label="$t('Toamount')" v-model="item.to_value" hide-details />
                    </v-flex>
                    <v-flex md1 sm1 xs1 px-1>
                      <h1 class="text-xs-center" style="padding-top: 0.5rem;">=</h1>
                    </v-flex>
                    <v-flex md2 sm2 xs4 px-1>
                      <v-text-field :label="$t('Rate')" v-model="item.tax" hide-details />
                    </v-flex>
                  </v-layout>
                </div>
                <v-layout row wrap py-2>
                  <v-flex xs12 class="text-xs-left">
                    <v-btn color="success" @click="plusTax()">
                      <v-icon :size="16">fa-plus</v-icon>
                      <span class="ml-2">{{ $t("Add_step") }}</span>
                    </v-btn>
                    <v-btn color="warning" @click="delTax()">
                      <v-icon :size="16">fa-minus</v-icon>
                      <span class="ml-2">{{ $t("Step_down") }}</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </tab-content>
          <tab-content title="ตั้งค่าสำเร็จ" icon="fas fa-check">
            <v-icon style="font-size:100px;" color="green darken-1">fa fa-check-circle</v-icon>
            <h3 style="margin-top:20px;font-size:24px;">ตั้งค่าสำเร็จ</h3>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <!-- <div class="wizard-footer-left">
              <wizard-button
                v-if="props.activeTabIndex > 0 && !props.isLastStep"
                @click.native="props.prevTab()"
                :style="props.fillButtonStyle"
              >Previous</wizard-button>
            </div>
            <div class="wizard-footer-right">
              <wizard-button
                v-if="!form_rules.company  && !props.isLastStep "
                @click.native="props.nextTab()"
                class="wizard-footer-right"
                :style="props.fillButtonStyle"
              >Next</wizard-button>

              <wizard-button
                v-else
                @click.native="onComplete()"
                class="wizard-footer-right finish-button"
                :style="props.fillButtonStyle"
              >{{props.isLastStep ? 'Done' : 'Next'}}</wizard-button>
            </div>-->
            <div>
              <div v-if="general_setting.use_cal_tax == '1'">
                <div class="wizard-footer-left">
                  <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <wizard-button v-if="!form_rules.company && !props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle"
                    >Next</wizard-button
                  >
                  <wizard-button v-else @click.native="onComplete()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{
                    props.isLastStep ? "Done" : "Next"
                  }}</wizard-button>
                </div>
              </div>
              <div v-else-if="general_setting.use_cal_tax != '1'">
                <div class="wizard-footer-left">
                  <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button>
                </div>
                <div class="wizard-footer-right">
                  <v-btn
                    v-if="props.activeTabIndex > 0 && !props.isLastStep"
                    color="#42A5F5"
                    @click="lastTab()"
                    class="wizard-footer-right"
                    style="color:#fff;padding:6px 12px;width:140px;height:35px"
                    >Nextss</v-btn
                  >
                  <wizard-button v-else @click.native="onComplete()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">{{
                    props.isLastStep ? "Done" : "Next"
                  }}</wizard-button>
                </div>
              </div>
            </div>
          </template>
        </form-wizard>
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* jshint ignore:start */
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import SettingService from "@/services/SettingService";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import numeral from "numeral";
export default {
  components: {
    FormWizard,
    TabContent,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        //this.form_model = val.data;
        this.getTaxDetail(val.data);
        //console.log("form_model" ,this.form_model)
      } else {
        //this.$refs.form.resetValidation();
        this.clearForm();
      }
    },
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
      //val && this.$nextTick(() => (this.listyear));
      //new Date().getFullYear()
    },
  },
  data: () => ({
    general_setting: {
      roworder: 0,
      finger_scan: 0,
      start_cal_late: 0,
      cal_work_day: 30,
      cal_decimal: 4,
      editor_code: "",
      code: "000-1",
      format_date: "1",
      symbols_style: "1",
      currency_symbols: "บาท",
      ss_base: 15000,
      ss_rate: 5,
      use_cal_tax: "0",
      use_cal_ss: "0",
      company_id: localStorage._company_guid,
    },
    is_use_cal_tax: true,
    is_use_cal_ss: true,
    taxstructure: [
      {
        line: 1,
        from_value: 0,
        to_value: 150000,
        tax: 0,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 2,
        from_value: 150001,
        to_value: 300000,
        tax: 5,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 3,
        from_value: 300001,
        to_value: 500000,
        tax: 10,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 4,
        from_value: 500001,
        to_value: 750000,
        tax: 15,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 5,
        from_value: 750001,
        to_value: 1000000,
        tax: 20,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 6,
        from_value: 1000001,
        to_value: 2000000,
        tax: 25,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 7,
        from_value: 2000001,
        to_value: 5000000,
        tax: 30,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
      {
        line: 8,
        from_value: 5000001,
        to_value: 0,
        tax: 35,
        basiccal: 0,
        deductline: 0,
        company_id: localStorage._company_guid,
      },
    ],
    img: "",
    address_setting: {
      roworder: 0,
      companyname: "",
      building: "", //อาคาร
      room_no: "", //ห้อง
      floor: "", //ชั้น
      village: "", //หมู่บ้าน
      house_no: "", //บ้านเลขที่
      village_no: "", //หมู่ที่
      alley_lane: "", //ตรอก/ซอย
      road: "", //ถนน
      subdistrict_subarea: "", //ตำบล/แขวง
      district_area: "", //อำเภอ/เขต
      province: "", //จังหวัด
      postcode: "", //รหัสไปรษณีย์
      telephone1: "",
      telephone2: "",
      code: "000-1",
      editor_code: "",
      imageLogo: "",
      taxpayer_number: "",
      line_id: "",
      facebook: "",
      twitter: "",
      company_id: localStorage._company_guid,
    },
    branch_model: {
      code: "00000",
      name: "สำนักงานใหญ่",
      remark: "",
      editorCode: localStorage._usercode,
      address: "",
      companyname: "",
      building: "", //อาคาร
      room_no: "", //ห้อง
      floor: "", //ชั้น
      village: "", //หมู่บ้าน
      house_no: "", //บ้านเลขที่
      village_no: "", //หมู่ที่
      alley_lane: "", //ตรอก/ซอย
      road: "", //ถนน
      subdistrict_subarea: "", //ตำบล/แขวง
      district_area: "", //อำเภอ/เขต
      province: "", //จังหวัด
      postcode: "", //รหัสไปรษณีย์
      telephone1: "",
      telephone2: "",
      editor_code: "",
      taxpayer_number: "",
      company_id: localStorage._company_guid,
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    form_rules: {
      companyname: [(v) => !!v || "do not empty."],
    },
    items: [],
    data_tax: [],
    data_allowances: [],
    year: null,
    years: { name: numeral(new Date().toISOString().substr(0, 4)).value() },
    menu: false,
    income: 0,
    jsondatatax: {
      year_tax: null,
      tax_detail: [],
      tax_cal: [],
      creator_code: null,
      company_id: localStorage._company_guid,
    },
    tax_detail: [
      {
        name: "add_income",
        type: 1,
        percent: 0,
        max: 0,
        company_id: localStorage._company_guid,
      },
      {
        name: "expensed",
        type: 0,
        percent: 50,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "personal",
        type: 0,
        percent: 0,
        max: 60000,
        company_id: localStorage._company_guid,
      },
      {
        name: "spouse",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "childen",
        type: 0,
        percent: 0,
        max: 90000,
        company_id: localStorage._company_guid,
      },
      {
        name: "residence",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "parent",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "handicapped",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "parent_insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "long_insurance",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "LTF",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
      {
        name: "RMF",
        type: 0,
        percent: 0,
        max: 100000,
        company_id: localStorage._company_guid,
      },
    ],
    taxsetting: {
      less_exp_rate: 50,
      less_exp_base: 100000,
      reduce_person: 60000,
      reduce_spouse: 60000,
      reduce_child_base: 30000,
      reduce_parent_base: 30000,
      reduce_handucap_base: 30000,
      reduce_insurance_base: 100000,
      reduce_parent_insurance_base: 15000,
      reduce_inc_residence_base: 100000,
      reduce_ltf: 500000,
      reduce_long_insurance: 200000,
      reduce_rmf: 500000,
      company_id: localStorage._company_guid,
    },
    checkdata: {},
  }),
  created: function() {
    this.commitSetToolbar({ patternTool: "2" });
    this.getCompanyAddress();
    this.getTaxSetting();
    this.getGeneralSetting();
    this.createyear();
    this.changeTaxVal();
    this.changeTaxVal1();
    this.getTaxDetail();
    console.log("5555", this.general_setting.use_cal_tax);
    this.data_allowances.push(
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      },
      {
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({ status: false, message: Object });
  },
  computed: {
    ...mapState("app", ["showLoading"]),
  },

  methods: {
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading", "commitGeneralSetting"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    async onComplete() {
      await this.onSaveCompanyAddress();
      await this.onSaveGeneralSetting();
      await this.onSaveTaxSetting();
      await this.onSaveBranch();
      await this.onUpdateSetShop();
      this.goto("dashboard");
    },
    lastTab() {
      console.log("11234");
      this.$refs.wizard.changeTab(1, 3);
    },
    clearForm() {
      this.general_setting = {
        roworder: 0,
        finger_scan: 0,
        start_cal_late: 0,
        cal_work_day: 30,
        cal_decimal: 4,
        editor_code: "",
        code: "000-1",
        format_date: "1",
        symbols_style: "1",
        currency_symbols: "บาท",
        ss_base: 15000,
        ss_rate: 5,
        use_cal_tax: "0",
        use_cal_ss: "0",
      };
    },
    // GeneralSetting//
    onUpdateSetShop() {
      SettingService.setShop()
        .then((res) => {})
        .catch((err) => {});
    },
    getGeneralSetting() {
      this.commitSetShowLoading(true);
      SettingService.getGeneralSetting()
        .then((res) => {
          if (res.data.content.length > 0) {
            this.general_setting = res.data.content[0];
            let format_date = res.data.content[0].format_date != null ? res.data.content[0].format_date.toString() : "1";
            let symbol_styles = res.data.content[0].currency_symbols != null ? res.data.content[0].currency_symbols.toString() : "บาท";
            let currency_symbols = res.data.content[0].symbols_style != null ? res.data.content[0].symbols_style.toString() : "1";

            this.general_setting.format_date = format_date;
            this.general_setting.currency_symbols = symbol_styles;
            this.general_setting.symbols_style = currency_symbols;

            this.commitGeneralSetting({
              format_date: format_date,
              symbol_styles: symbol_styles,
              currency_symbols: currency_symbols,
            });
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    onSaveGeneralSetting() {
      this.commitSetShowLoading(true);
      this.general_setting.editor_code;
      console.log("general_setting: ", this.general_setting);
      SettingService.saveGeneralSetting(this.general_setting)
        .then((res) => {
          this.getGeneralSetting();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },

    //CompanyAddress//
    getCompanyAddress() {
      this.commitSetShowLoading(true);
      SettingService.getCompanyAddress()
        .then((res) => {
          if (res.data.content.length > 0) {
            this.address_setting = res.data.content[0];
            if (this.address_setting.imageLogo != "" && this.address_setting.imageLogo != null && this.address_setting.imageLogo != undefined) {
              this.img = this.address_setting.imageLogo;
            }
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    uploadPic($event) {
      const elem = this.$refs.file1;
      elem.click();
    },
    onSaveCompanyAddress() {
      this.address_setting.imageLogo = "";
      if (this.img != "") {
        var rep_img1 = this.img.replace("data:image/png;base64,", "");
        var rep_img2 = rep_img1.replace("data:image/gif;base64,", "");
        var rep_img3 = rep_img2.replace("data:image/jpg;base64,", "");
        var rep_img4 = rep_img3.replace("data:image/bmp;base64,", "");
        var rep_img5 = rep_img4.replace("data:image/jpeg;base64,", "");

        this.address_setting.imageLogo = rep_img5;
      }
      this.commitSetShowLoading(true);
      SettingService.saveCompanyAddress(this.address_setting)
        .then((res) => {
          this.getCompanyAddress();
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(true);
        });
    },
    onSaveBranch() {
      SettingService.saveBranch(this.branch_model)
        .then((res) => {})
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    onChangePicture($event, index) {
      this.readThisdata($event.target, index);
    },
    readThisdata(inputValue, index) {
      const file = inputValue.files[0];
      const myReader = new FileReader();
      myReader.onloadend = (e) => {
        this.img = myReader.result;
      };
      myReader.readAsDataURL(file);
    },
    getTaxSetting() {
      this.commitSetShowLoading(true);
      //this.taxstructure = this.data_tax;
      console.log("start taxstructure");
      let v = this;
      this.taxstructure.forEach(function(element, index) {
        if (index + 1 == v.taxstructure.length) {
          element.basiccal = 0;
        } else if (index > 0) {
          element.basiccal = element.to_value - v.taxstructure[index - 1].to_value;
          console.log("basiccal", element.basiccal);
        } else {
          element.basiccal = element.to_value;
        }
        element.deductline = element.basiccal * (element.tax / 100);
      });
      console.log(this.taxstructure);
      SettingService.getTaxSetting()
        .then((res) => {
          console.log(res);
          this.data_tax = [];
          if (res.data.content.length > 0) {
            // for (let index = 1; index < res.data.content.length; index++) {
            //   this.data_tax.push({
            //     line_number: index,
            //     from_value: res.data.content[index].from_value,
            //     to_value: res.data.content[index].to_value,
            //     tax: res.data.content[index].tax,
            //     basiccal: res.data.content[index].basiccal,
            //     deductline: res.data.content[index].deductline
            //   });
            //
            // }
            for (let index = 0; index < res.data.content.length; index++) {
              this.data_tax.push({
                line_number: this.taxstructure[index].line_number,
                from_value: res.data.content[index].from_value,
                to_value: res.data.content[index].to_value,
                tax: res.data.content[index].tax,
                basiccal: res.data.content[index].basiccal,
                deductline: res.data.content[index].deductline,
              });
              console.log("index: ", index);
            }
            console.log("data tax: ", this.data_tax);
            //console.log("if taxstructure");
            console.log(this.data_tax);
          } else if (res.data.content == []) {
            for (let index = 1; index < this.taxstructure.length; index++) {
              this.data_tax.push({
                line_number: this.taxstructure[index].line_number,
                from_value: this.taxstructure[index].from_value,
                to_value: this.taxstructure[index].to_value,
                tax: this.taxstructure[index].tax,
                basiccal: this.taxstructure[index].basiccal,
                deductline: this.taxstructure[index].deductline,
              });
              console.log("index: ", index);
            }

            console.log("taxstructure");
            console.log(this.taxstructure);
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    async onSaveTaxSetting() {
      this.commitSetShowLoading(true);
      let v = this;
      console.log("income: ", this.income);
      console.log("data_tax: ", this.data_tax);
      for (let index = 0; index < this.taxstructure.length; index++) {
        this.jsondatatax.tax_cal.push({
          line_number: this.taxstructure[index].line,
          from_value: this.taxstructure[index].from_value,
          to_value: this.taxstructure[index].to_value,
          tax: this.taxstructure[index].tax,
          basiccal: this.taxstructure[index].basiccal,
          deductline: this.taxstructure[index].deductline,
          company_id: localStorage._company_guid,
        });
      }
      // if (this.data_tax.length == 0) {
      //   for (let index = 1; index < this.taxstructure.length; index++) {
      //     this.jsondatatax.tax_cal.push({
      //       line_number: this.taxstructure[index].line,
      //       from_value: this.taxstructure[index].from_value,
      //       to_value: this.taxstructure[index].to_value,
      //       tax: this.taxstructure[index].tax,
      //       basiccal: this.taxstructure[index].basiccal,
      //       deductline: this.taxstructure[index].deductline
      //     });
      //   }
      //   this.jsondatatax.tax_cal = this.data_tax;
      //   console.log(this.jsondatatax.tax_cal);
      // } else {
      //   this.jsondatatax.tax_cal = this.data_tax;
      // }
      //this.jsondatatax.tax_cal = this.taxstructure;
      console.log("tax_cal: ", this.jsondatatax.tax_cal);
      for (let i = 0; i < this.tax_detail.length; i++) {
        if (this.tax_detail[i].name == "add_income") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.income,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "expensed") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.less_exp_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "spouse") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_spouse,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "personal") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_person,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "childen") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_child_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "residence") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_insurance_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "parent") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "handicapped") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_handucap_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_inc_residence_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "parent_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_parent_insurance_base,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "long_insurance") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_long_insurance,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "LTF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_ltf,
            company_id: localStorage._company_guid,
          });
        } else if (this.tax_detail[i].name == "RMF") {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.taxsetting.reduce_rmf,
            company_id: localStorage._company_guid,
          });
        } else {
          this.jsondatatax.tax_detail.push({
            name: this.tax_detail[i].name,
            type: this.tax_detail[i].type,
            percent: this.tax_detail[i].percent,
            max: this.tax_detail[i].max,
            company_id: localStorage._company_guid,
          });
        }
      }
      console.log("data_allowances length" + this.data_allowances.length);
      for (let i = 0; i < this.data_allowances.length; i++) {
        if (this.data_allowances[i].name != null) {
          this.jsondatatax.tax_detail.push({
            name: this.data_allowances[i].name,
            type: this.data_allowances[i].type,
            percent: this.data_allowances[i].percent,
            max: this.data_allowances[i].max,
            company_id: localStorage._company_guid,
          });
          console.log("add data_allowances");
        } else {
          console.log("not add data_allowances");
        }
      }

      var year;
      if (this.years.name != null) {
        year = this.years.name;
      } else {
        year = this.years;
      }
      console.log("onsave year" + year);
      this.jsondatatax.year_tax = year;
      this.jsondatatax.creator_code = localStorage._usercode;
      console.log(this.jsondatatax);
      await SettingService.createTaxdetail(this.jsondatatax)
        .then((res) => {
          console.log("save success");
        })
        .catch((err) => {
          this.commitSetShowLoading(false);
          console.log(err.response.data);
        });
    },
    plusTax() {
      let line = this.taxstructure.length + 1;
      this.data_tax.push({
        line: line,
        from_value: 0,
        to_value: 0,
        tax: 0,
        basiccal: 0,
        deductline: 0,
      });
    },
    delTax() {
      this.data_tax.splice(-1, 1);
    },
    validateFirstStep() {
      console.log(this.address_setting.companyname);
      if (this.address_setting.companyname != "") {
        return true;
      } else {
        return new Promise((resolve, reject) => {
          this.snack_model.status = true;
          this.snack_model.msg = "กรุณาระบุชื่อร้าน";
          this.snack_model.type = "error";
          this.form_rules.companyname((valid) => {
            resolve(valid);
          });
        });
      }
    },
    plusallowances() {
      let line = this.data_allowances.length + 1;
      this.data_allowances.push({
        type: 0,
        percent: 0,
        name: null,
        max: 0,
      });
    },
    delallowances() {
      this.data_allowances.splice(-1, 1);
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 10;
      var endyear = parseInt(curryears) + 10;
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = startyear; d <= endyear; d++) {
        this.items.push({ name: d });
      }
      console.log(this.items);

      console.log("year", this.years.name);
      console.log("data_tax", this.taxstructure);
    },
    changeTaxVal() {
      // if (this.is_use_cal_tax) {
      //   this.general_setting.use_cal_tax = "0";
      //   console.log("if ", this.general_setting.use_cal_tax);
      //   console.log("if ", this.is_use_cal_tax);
      // } else {
      //   this.general_setting.use_cal_tax = "1";
      //   console.log("else ", this.general_setting.use_cal_tax);
      // }
      // console.log("dddd", this.general_setting.use_cal_tax);
      if (this.is_use_cal_tax == true) {
        this.general_setting.use_cal_tax = "1";
        console.log("if tax", this.general_setting.use_cal_tax);
        console.log("if tax", this.is_use_cal_tax);
      } else {
        this.general_setting.use_cal_tax = "0";
        console.log("else tax", this.general_setting.use_cal_tax);
      }
    },
    changeTaxVal1() {
      // if (this.use_cal_ss) {
      //   this.general_setting.use_cal_ss = "0";
      //   console.log("if ", this.general_setting.use_cal_ss);
      //   console.log("if ", this.is_use_cal_ss);
      // } else {
      //   this.general_setting.use_cal_ss = "1";
      //   console.log("else ", this.general_setting.use_cal_ss);
      // }
      // console.log("dddd", this.general_setting.use_cal_ss);
      if (this.is_use_cal_ss == true) {
        this.general_setting.use_cal_ss = "1";
        console.log("if ss", this.general_setting.use_cal_ss);
        console.log("if ss", this.is_use_cal_ss);
      } else {
        this.general_setting.use_cal_ss = "0";
        console.log("else ss", this.general_setting.use_cal_ss);
      }
      console.log("d", this.general_setting.use_cal_ss);
    },
    getTaxDetail() {
      var year;
      if (this.years.name != null) {
        year = this.years.name;
      } else {
        year = this.years;
      }
      SettingService.getTaxdetail(year)
        .then((res) => {
          console.log("input years: " + year);
          /*start chang year not data*/
          this.data_allowances = [];
          this.data_allowances.push(
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            },
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            },
            {
              type: 0,
              percent: 0,
              name: null,
              max: 0,
            }
          );
          this.taxsetting.less_exp_rate = 50;
          this.taxsetting.less_exp_base = 100000;
          this.taxsetting.reduce_person = 60000;
          this.taxsetting.reduce_spouse = 60000;
          this.taxsetting.reduce_child_base = 90000;
          this.taxsetting.reduce_parent_base = 60000;
          this.taxsetting.reduce_handucap_base = 30000;
          this.taxsetting.reduce_insurance_base = 100000;
          this.taxsetting.reduce_parent_insurance_base = 15000;
          this.taxsetting.reduce_inc_residence_base = 100000;
          this.taxsetting.reduce_ltf = 500000;
          this.taxsetting.reduce_long_insurance = 200000;
          this.taxsetting.reduce_rmf = 500000;

          /*close*/
          console.log("data", res);
          this.checkdata = res.data;
          console.log(this.checkdata);
          if (res.data != "") {
            this.jsondatatax = res.data;
            console.log(res.data);
            console.log(this.jsondatatax);
            //**return data *//
            this.data_allowances = [];
            this.taxsetting;
            this.data_tax = this.jsondatatax.tax_cal;
            console.log("have data", this.data_tax);
            for (let index = 0; index < this.jsondatatax.tax_detail.length; index++) {
              if (this.jsondatatax.tax_detail[index].name == "add_income") {
                this.income = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "expensed") {
                this.taxsetting.less_exp_base = this.jsondatatax.tax_detail[index].max;
                this.taxsetting.less_exp_rate = this.jsondatatax.tax_detail[index].percent;
              } else if (this.jsondatatax.tax_detail[index].name == "spouse") {
                this.taxsetting.reduce_spouse = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "personal") {
                this.taxsetting.reduce_person = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "childen") {
                this.taxsetting.reduce_child_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "residence") {
                this.taxsetting.reduce_insurance_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "parent") {
                this.taxsetting.reduce_parent_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "handicapped") {
                this.taxsetting.reduce_handucap_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "insurance") {
                this.taxsetting.reduce_inc_residence_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "parent_insurance") {
                this.taxsetting.reduce_parent_insurance_base = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "long_insurance") {
                this.taxsetting.reduce_long_insurance = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "LTF") {
                this.taxsetting.reduce_ltf = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[index].name == "RMF") {
                this.taxsetting.reduce_rmf = this.jsondatatax.tax_detail[index].max;
              } else if (this.jsondatatax.tax_detail[12]) {
                this.data_allowances.push({
                  name: this.jsondatatax.tax_detail[index].name,
                  type: this.jsondatatax.tax_detail[index].type,
                  percent: this.jsondatatax.tax_detail[index].percent,
                  max: this.jsondatatax.tax_detail[index].max,
                });
                console.log("getTaxDetail :", this.data_allowances);
              }
            }
          } else if (res == "") {
            console.log("not data year", this.years);
            this.income = 0;
            this.jsondatatax.year_tax = "";
            this.jsondatatax.tax_detail = [];
            this.jsondatatax.tax_cal = [];
            this.jsondatatax.creator_code = "";
            this.data_allowances = [];
            console.log("not data", this.data_tax);
            this.getTaxSetting();
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h3 {
  font-family: "Prompt", sans-serif;
}
</style>
